import { forwardRef as o } from "react";
const f = o;
export {
  f as forwardRefPolymorphic
};
